<template>
  <div
    id="wrapper"
    class="wrapper"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <ReleasePopup
      v-if="document"
      :show="showReleasePopupModal"
      :document="document"
      @closeModalReleasePopup="closeModalReleasePopup"
    />
    <notifications></notifications>
    <dashboard-navbar :show="true"></dashboard-navbar>

    <div id="preloader" class="global-preloader" v-if="load">
      <div class="preloader-content">
        <img
          src="~rhomtrip_assets/src/img/icons/rhomtrip-icon.gif"
          alt="Loading..."
          class="preloader-image"
        />

        <div class="preloader-bar-container">
          <div
            class="preloader-bar"
            :style="{ width: progressBarWidth + '%' }"
          ></div>
        </div>
        <p class="preloader-text" data-aos="fade">Loading...</p>
      </div>
    </div>

    <side-bar>
      <template slot-scope slot="links">
        <img :src="getLogo()" class="logo-icon" alt="Rhomtrip" />

        <div class="nav-item text-center d-lg-block d-md-none">
          <span
            @click="openSidebar"
            class="icon-open-close"
            :class="{
              'close-side': verticalSidebar == false,
              'open-side': verticalSidebar == true
            }"
            ><i
              :class="{
                'flaticon-menu-3 ': verticalSidebar == false,
                'flaticon-menu-2': verticalSidebar == true
              }"
            ></i
          ></span>
        </div>

        <sidebar-item
          :link="{
            name: 'Reservations',
            icon: 'flaticon-calendar',
            path: '/reservations'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Customers',
            icon: 'flaticon-employees',
            path: '/customers'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Destinations',
            icon: 'flaticon-pin',
            path: '/destinations'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Areas',
            icon: 'flaticon-radar ',
            path: '/coverage-areas'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Vehicles',
            icon: 'flaticon-car',
            path: '/vehicles'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Rates',
            icon: 'flaticon-bold-list ',
            path: '/rates'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Drivers',
            icon: 'flaticon-driver-license',
            path: '/drivers'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Schedule',
            icon: 'flaticon-history',
            path: '/schedules'
          }"
          v-if="
            sesion.role === 'admin' ||
              sesion.role === 'supplier' ||
              sesion.role === 'company'
          "
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Users',
            icon: 'flaticon-costumer',
            path: '/users'
          }"
          v-if="sesion.role === 'supplier' || sesion.role === 'company'"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <globalFooter class="global-foot"></globalFooter>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Pusher from "pusher-js"; // import Pusher
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../Commons/Services";
import globalFooter from "../Layout/GlobalFooter";
import ReleasePopup from "../Components/PopupRelease.vue";
import { changePrimaryColor } from "../../helpers/commons.helpers";
/**
 * Checks if an element with the given class exists in the DOM.
 * @param {string} className - The class name to search for.
 * @returns {boolean}
 */
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

/**
 * Initializes PerfectScrollbar on the given class.
 * Retries if the element is not yet available.
 * @param {string} className - The class name to initialize the scrollbar on.
 */
function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
export default {
  name: "DashboardLayout",
  data() {
    return {
      verticalSidebar: false,
      pusher: null,
      subscribeChannel: null,
      progress: 0,
      showReleasePopupModal: false,
      document: null
    };
  },
  watch: {
    /**
     * Watches for changes in the user profile status.
     */
    profile: {
      handler: function(current, old) {
        if (!current.status) {
          changePrimaryColor("#4b56a6", "#FFFFFF");
          localStorage.removeItem("es-login");
          localStorage.removeItem("settings");
          this.setResponseReservations({});
          this.setDrivers({});
          this.setOperatorRespose({});
          this.setResponseBranch({});
          this.setResponseArea({});
          this.setVehicles({});
          this.setAdvancedSearch("");
          this.$router.push({ path: "/signin" });
        }
      },
      deep: true
    },
    /**
     * Watches for changes in the loading state.
     */
    load: {
      handler: function(current, old) {
        if (current) {
          this.progress = 0;
          this.simulateLoading();
        }
      },
      deep: true
    }
  },
  async created() {
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.subscribeChannel = this.pusher.subscribe("rhombuss");
    this.initScrollbar();
    this.getSesion();
    if (this.sesion) {
      await this.getModuleSettings();
      await this.getUserDetails(this.sesion);
      this.getCustomerOptions();
      this.getCountries();
      this.getBranchesOptions();
      this.watchCustomersUpdates(
        this.subscribeChannel,
        "customers",
        this.getCustomerOptions
      );
      this.watchReleaseUpdates(this.subscribeChannel, "new-release");
    }
  },
  async mounted() {
    const systemInfo = await this.getCurrentReleaseByApp("SUPPLIERS");
    if (systemInfo) {
      this.setSystemInfo({
        name: this.systemInfo.name,
        year: this.systemInfo.year,
        ...systemInfo
      });
      const latestNewsAvailable = await this.checkViewedRelease(
        "SUPPLIERS",
        this.systemInfo.release.version,
        this.sesion.id
      );
      this.setLatestNewsAvailable(latestNewsAvailable);
      this.handleAppVersion(systemInfo);
    }
  },
  methods: {
    /**
     * Initializes the custom scrollbar for Windows users.
     */
    initScrollbar() {
      const docClasses = document.body.classList;
      const isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("scrollbar-inner");
        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    /**
     * Fetches and sets user details including profile and settings.
     * @param {Object} sesion - The current session object.
     */
    async getUserDetails() {
      let userId = this.sesion.id;
      let role = this.sesion.role;
      let accessType = this.sesion.account_type.type;
      let operatorId = this.getOperatorId(this.sesion);
      let settings = await this.getSettingsOperator(
        operatorId,
        this.sesion.token
      );
      this.setSettings(settings);
      this.applySettingsChanges(settings);
      let user = await this.getProfileUser(
        userId,
        role,
        accessType,
        this.sesion.token
      );
      if (user) {
        this.setProfile(user);
      }
    },
    /**
     * Fetches the profile information for a user.
     * @param {string} userId - The ID of the user.
     * @param {string} role - The role of the user.
     * @param {string} type - The account type of the user.
     * @param {string} token - The authentication token.
     * @returns {Object} - The profile object containing first name, last name, url picture, and status.
     */
    async getProfileUser(userId, role, type, token) {
      try {
        let { data } = await endpoint.profile.services.getProfileUser(
          userId,
          role,
          type,
          token
        );
        if (data.status) {
          let user = data.data;
          return {
            last_name:
              type === role
                ? user.contactPerson.lastName
                : user.personal_info.last_name,
            first_name:
              type === role
                ? user.contactPerson.firstName
                : user.personal_info.first_name,
            url_picture:
              type === role ? user.businessDetails.image : user.profile.image,
            status: true
          };
        } else {
          return {
            first_name: "",
            last_name: "",
            url_picture: "",
            status: false
          };
        }
      } catch (error) {
        return {
          first_name: "",
          last_name: "",
          url_picture: "",
          status: false
        };
      }
    },
    /**
     * Fetches the settings for the given operator.
     * @param {string} operatorid - The ID of the operator.
     * @param {string} token - The authentication token.
     * @returns {Object|null} - The settings object or null if an error occurs.
     */
    async getSettingsOperator(operatorid, token) {
      try {
        let { data } = await endpoint.settings.services.getSettings(
          operatorid,
          token
        );
        if (data.status) {
          let settings = data.data;
          return {
            maximumDistance: settings.maximumDistance,
            measurementUnit: settings.measurementUnit,
            language: settings.language,
            currency: settings.currency,
            timeZone: settings.timeZone,
            timeFormat: settings.timeFormat,
            dateFormat: settings.dateFormat,
            layout: settings.settings,
            brand: settings.brand,
            permissions: settings.permissions
          };
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    /**
     * Opens the sidebar.
     */
    openSidebar() {
      this.verticalSidebar = !this.verticalSidebar;
      let docClasses = document.body.classList;
      if (this.verticalSidebar === true) {
        docClasses.add("g-sidenav-pinned");
      } else {
        docClasses.remove("g-sidenav-pinned");
      }
    },
    /**
     * Subscribes to customer updates on the given channel and event.
     * @param {Object} channel - The Pusher channel to subscribe to.
     * @param {string} event - The event name to listen for.
     * @param {Function} callback - The callback function to execute when the event is triggered.
     */
    watchCustomersUpdates(channel, event, callback) {
      channel.bind(event, data => {
        if (["supplier", "supplier_access"].includes(this.sesion.role)) {
          let owner = this.getOperatorId(this.sesion);
          if (data.owner === owner) {
            callback();
          }
        }
      });
    },
    /**
     * Subscribes to release updates on the given channel and event.
     * @param {Object} channel - The Pusher channel to subscribe to.
     * @param {string} event - The event name to listen for.
     */
    watchReleaseUpdates(channel, event) {
      channel.bind(event, data => {
        let apps = ["SUPPLIERS"];
        if (apps.includes(data.data.app)) {
          this.setLatestNewsAvailable(true);
          this.setSystemInfo({
            name: this.systemInfo.name,
            year: this.systemInfo.year,
            ...data.data
          });
          this.handleAppVersion(data.data);
        }
      });
    },
    /**
     * Formats a date string into a more readable format.
     * @param {string} dateStr - The date string to format.
     * @returns {string} - The formatted date string.
     */
    getOperatorId(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    /**
     * Simulates a loading progress bar.
     * Increments the progress value until it reaches 100%.
     */
    simulateLoading() {
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 10;
        } else {
          clearInterval(interval);
        }
      }, 500);
    },
    /**
     * Applies settings changes such as theme color based on the provided settings object.
     * @param {Object} settings - The settings object containing brand and theme information.
     */
    applySettingsChanges(settings) {
      if (settings.permissions.brand) {
        changePrimaryColor(
          settings.brand.theme.color,
          settings.brand.theme.buttonText
        );
      } else {
        changePrimaryColor("#4b56a6", "#FFFFFF");
      }
    },
    /**
     * Returns the logo URL based on the current settings.
     * @returns {string} - The URL of the logo image.
     */
    getLogo() {
      if (this.settings) {
        if (this.settings.permissions.brand) {
          return this.settings.brand.logos.favicon
            ? this.settings.brand.logos.favicon
            : require("rhomtrip_assets/src/img/brand/icon-rhomtrip-150x158.png");
        }
      }
      return require("rhomtrip_assets/src/img/brand/icon-rhomtrip-150x158.png");
    },

    /**
     * Fetches the current release information for the given app.
     * @param {string} app
     * @returns {Object|null}
     */
    async getCurrentReleaseByApp(app) {
      try {
        const {
          data
        } = await endpoint.documents.services.getCurrentReleaseByApp(
          app,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return null;
      } catch (error) {
        return null;
      }
    },

    /**
     * Checks if the user has viewed the latest release.
     * @param {string} app
     * @param {string} releaseVersion
     * @param {string} userId
     * @returns {boolean}
     */
    async checkViewedRelease(app, releaseVersion, userId) {
      try {
        const { data } = await endpoint.documents.services.checkViewedRelease(
          app,
          releaseVersion,
          userId,
          this.sesion.token
        );
        if (data.status) {
          return !data.data.wasViewed;
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    /**
     * Opens the release popup modal.
     */
    openModalReleasePopup() {
      this.showReleasePopupModal = true;
    },
    /**
     * Closes the release popup modal.
     * @param {boolean} status
     */
    closeModalReleasePopup(status) {
      this.showReleasePopupModal = status;
    },
    /**
     * Handles application version changes and triggers the release popup if needed.
     * @param {Object} systemInfo
     */
    handleAppVersion(systemInfo) {
      if (systemInfo && systemInfo.release) {
        const currentVersion = systemInfo.release.version;
        const storedVersion = localStorage.getItem("appVersion");
        if (storedVersion && storedVersion !== currentVersion) {
          this.document = systemInfo;
          this.openModalReleasePopup();
        } else {
          if (!storedVersion) {
            localStorage.setItem("appVersion", currentVersion);
          }
        }
      }
    },
    ...mapActions([
      "getSesion",
      "getCountries",
      "getBranchesOptions",
      "getCustomerOptions",
      "getModuleSettings"
    ]),
    ...mapMutations([
      "setSettings",
      "setProfile",
      "setResponseReservations",
      "setDrivers",
      "setOperatorRespose",
      "setResponseBranch",
      "setResponseArea",
      "setVehicles",
      "setAdvancedSearch",
      "setLatestNewsAvailable",
      "setSystemInfo"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  },
  computed: {
    progressBarWidth() {
      return this.progress;
    },
    ...mapGetters([
      "sesion",
      "load",
      "settings",
      "profile",
      "systemInfo",
      "latestNewsAvailable"
    ])
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    globalFooter: globalFooter,
    ReleasePopup
  }
};
</script>
